import React from "react";
import "./App.css";
import Navbar from "./comp/Navbar";
import Textarea from "./comp/Textarea";
// import Textarea from "./comp/Textarea";

function App() {
  
  return (
    <div className="app" >
      {/* <Navbar /> */}
      <Textarea/>
    </div>
  );
}

export default App;
